module.exports = __webpack_public_path__ + "img/consult_info7.acbe4327.png";